// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchPartnerWithdrawals } from "../../redux/WithdralSlice/withdrawalSlice";

// const PartnerWithdrawalsHistory = ({}) => {
//   const dispatch = useDispatch();
//   const { withdrawals, loading, error } = useSelector(
//     (state) => state.withdrawals
//   );
//   const userData = JSON.parse(sessionStorage.getItem("user")) || {};
//   const userId = userData.userId;
//   console.log("userId", userId);

//   useEffect(() => {
//     dispatch(fetchPartnerWithdrawals(userId));
//   }, [dispatch, userId]);

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold mb-4">My Withdrawal History</h1>

//       {loading && <p>Loading...</p>}
//       {error && <p className="text-red-500">{error}</p>}

//       <ul>
//         {withdrawals?.map((w) => (
//           <li key={w._id} className="border-b p-2">
//             ₹{w.amount} - {w.status.toUpperCase()}{" "}
//             {w.transactionId && `(Txn: ${w.transactionId})`}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default PartnerWithdrawalsHistory;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartnerWithdrawals } from "../../redux/WithdralSlice/withdrawalSlice";
import moment from "moment";
import { fetchpartnerbyId } from "../../redux/slices/partnerSlice";

const PartnerWithdrawalsHistory = () => {
  const dispatch = useDispatch();
  const partner = useSelector((state) => state?.partner);
  const data = partner?.fetchById;
  const { withdrawals, loading, error } = useSelector(
    (state) => state.withdrawals
  );

  const userData = JSON.parse(sessionStorage.getItem("user")) || {};
  const userId = userData.userId;

  useEffect(() => {
    dispatch(fetchPartnerWithdrawals(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    if (!data) {
      dispatch(fetchpartnerbyId(userId));
    }
  }, [data, dispatch, userId]);

  // Function to mask account number
  const maskAccountNumber = (accountNumber) => {
    return accountNumber ? `****${accountNumber.slice(-4)}` : "Unknown Account";
  };

  const bankDetails = data?.bankDetails || {};
  const { bankName, accountNumber } = bankDetails;

  // Generate random colors for profile icons
  const getRandomColor = (name) => {
    const colors = [
      "bg-red-500",
      "bg-green-500",
      "bg-blue-500",
      "bg-purple-500",
      "bg-pink-500",
      "bg-yellow-500",
    ];
    return colors[name.charCodeAt(0) % colors.length];
  };

  // Function to get status color
  const getStatusColor = (status) => {
    const statusColors = {
      approved: "text-green-500",
      rejected: "text-red-500",
      pending: "text-orange-500",
      processing: "text-blue-500",
    };
    return statusColors[status.toLowerCase()] || "text-gray-500";
  };

  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const getStatusBackgroundColor = (status) => {
    const statusColors = {
      approved: "bg-green-500",
      rejected: "bg-red-500",
      pending: "bg-orange-500",
      processing: "bg-blue-500",
    };
    return statusColors[status.toLowerCase()] || "bg-gray-500";
  };

  return (
    <div className="p-0 min-h-screen">
      {/* <h1 className="text-xl font-bold mb-4">Withdrawal History</h1> */}
      <h2 className="text-xl font-bold mb-4 text-center text-gray-800">
        Withdrawal History
      </h2>
      {loading && <p className="text-blue-500">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      <div className="rounded-lg p-0">
        {withdrawals?.map((w) => (
          <div
            key={w._id}
            className="flex items-center justify-between p-3 border-b cursor-pointer hover:bg-gray-100"
            onClick={() => setSelectedTransaction(w)}
          >
            <div className="flex items-center">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full text-white text-lg ${getStatusBackgroundColor(
                  w.status
                )}`}
              >
                {bankName?.charAt(0) || "B"}
              </div>

              <div className="ml-3">
                <p className="font-semibold">{bankName || "Bank"}</p>
                <p className="text-gray-500 text-sm">
                  {moment(w.requestedAt.$date).format("DD MMMM")}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-semibold">₹{w.amount.toFixed(2)}</p>
              <p
                className={`text-xs font-semibold ${getStatusColor(w.status)}`}
              >
                {w.status.charAt(0).toUpperCase() + w.status.slice(1)}
              </p>
            </div>
          </div>
        ))}
        {withdrawals?.length === 0 && (
          <p className="text-center text-gray-500 py-4">
            No withdrawals found.
          </p>
        )}
      </div>

      {selectedTransaction && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4"
          onClick={() => setSelectedTransaction(null)}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-4 text-center text-gray-800">
              Transaction Details
            </h2>
            <div className="border-t border-gray-300">
              <div className="py-3 flex justify-between border-b">
                <span className="text-gray-600 font-medium">Bank</span>
                <span className="text-gray-800">{bankName || "Bank"}</span>
              </div>
              <div className="py-3 flex justify-between border-b">
                <span className="text-gray-600 font-medium">Account</span>
                <span className="text-gray-800">
                  {maskAccountNumber(accountNumber)}
                </span>
              </div>
              <div className="py-3 flex justify-between border-b">
                <span className="text-gray-600 font-medium">Date</span>
                <span className="text-gray-800">
                  {moment(selectedTransaction.requestedAt.$date).format(
                    "DD MMMM YYYY, hh:mm A"
                  )}
                </span>
              </div>
              <div className="py-3 flex justify-between border-b">
                <span className="text-gray-600 font-medium">Amount</span>
                <span className="text-gray-800 font-semibold">
                  ₹{selectedTransaction.amount.toFixed(2)}
                </span>
              </div>
              <div className="py-3 flex justify-between border-b">
                <span className="text-gray-600 font-medium">
                  Transaction ID
                </span>
                <span className="text-gray-800">
                  {selectedTransaction.transactionId || "N/A"}
                </span>
              </div>
              <div className="py-3 flex justify-between">
                <span className="text-gray-600 font-medium">Status</span>
                <span
                  className={`font-semibold ${getStatusColor(
                    selectedTransaction.status
                  )}`}
                >
                  {selectedTransaction.status.charAt(0).toUpperCase() +
                    selectedTransaction.status.slice(1)}
                </span>
              </div>
            </div>
            <button
              className="mt-6 w-full bg-blue-500 text-white p-2 rounded-lg font-medium hover:bg-blue-600 transition"
              onClick={() => setSelectedTransaction(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerWithdrawalsHistory;
